import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementPlus from 'element-plus';
import * as ElementPlusIcons from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

import { Permission } from '@/plugins/directive';
import DataSelect from 'components/DataSelect.vue';
import UserTips from 'components/UserTips.vue';
import OrgSelect from 'components/OrgSelect.vue';
import UserSelect from 'components/UserSelect.vue';
import Selector from 'components/Selector.vue';
import QSelect from 'components/QSelect.vue';
import TSelect from 'components/TSelect.vue';
import Autocomplete2 from 'components/Autocomplete2.vue';
import Autocomplete from 'components/Autocomplete.vue';
import TAutocomplete from 'components/TAutocomplete.vue';
import TAutocomplete2 from 'components/TAutocomplete2.vue';
import QAutocomplete from 'components/QAutocomplete.vue';
import StatusTag from 'components/StatusTag.vue';

import './main.scss';
import 'virtual:uno.css';
import VConsole from 'vconsole';
import { initDrag } from './plugins/dragMove';

const app = createApp(App);

app.use(router);
app.use(ElementPlus, {
    locale: zhCn
});
app.use(store);
app.directive('permission', Permission);
app.component('DataSelect', DataSelect);
app.component('UserTips', UserTips);
app.component('OrgSelect', OrgSelect);
app.component('UserSelect', UserSelect);
app.component('Selector', Selector);
app.component('QSelect', QSelect);
app.component('TSelect', TSelect);
app.component('Autocomplete', Autocomplete);
app.component('Autocomplete2', Autocomplete2);
app.component('TAutocomplete', TAutocomplete);
app.component('TAutocomplete2', TAutocomplete2);
app.component('QAutocomplete', QAutocomplete);
app.component('StatusTag', StatusTag);

for (const [key, component] of Object.entries(ElementPlusIcons)) {
    app.component(key, component);
}

const render = (container) => {
    // 如果是在主应用的环境下就挂载主应用的节点，否则挂载到本地
    const appDom = container || '#app';
    app.mount(appDom);
};

const hasConsole = localStorage.getItem('vconsoleBtn');
if (hasConsole) {
    new VConsole();
}

render(null);

// 使用方法：initDrag('draggable-element-id');
initDrag('__iknow_robot_button__');
